import { createSlice } from "@reduxjs/toolkit";

export type GenericInitialStateType = {
	showSideNav: boolean
}

export const initialState: GenericInitialStateType = {
	showSideNav: false,
};

const genericSlice = createSlice({
	name: "generic",
	initialState,
	reducers: {
		toggleSideNav: (state) => {
			state.showSideNav = !state.showSideNav;
		},
	},
});

export const { toggleSideNav } = genericSlice.actions;

export const genericReducer = genericSlice.reducer;
